import azureDevOpsService from './azureDevOpsService';

function authHeaders() {
  const pat = azureDevOpsService.getPat();
  return pat ? { 'X-Azure-Devops-Pat': pat } : {};
}

class AiAgentService {
  async analyzeTestFailure(payload) {
    const response = await fetch('/api/ai/analyze-test-failure', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...authHeaders()
      },
      body: JSON.stringify(payload || {})
    });

    const text = await response.text();
    const data = text ? JSON.parse(text) : {};

    if (!response.ok) {
      throw new Error(data.error || `Erreur analyse IA (${response.status})`);
    }

    return data;
  }

  async getHealth() {
    const response = await fetch('/api/ai/health');
    const text = await response.text();
    const data = text ? JSON.parse(text) : {};
    if (!response.ok) {
      throw new Error(data.error || `Erreur health IA (${response.status})`);
    }
    return data;
  }

  async fetchArtifactLog(payload) {
    const response = await fetch('/api/ai/artifact-log', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...authHeaders() },
      body: JSON.stringify(payload || {})
    });
    if (!response.ok) {
      const text = await response.text();
      let data;
      try { data = JSON.parse(text); } catch { data = {}; }
      throw new Error(data.error || `Log indisponible (${response.status})`);
    }
    return response.text();
  }

  async previewFix(payload, onStatus) {
    const response = await fetch('/api/ai/preview-fix', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...authHeaders() },
      body: JSON.stringify(payload || {})
    });

    if (!response.ok) {
      const text = await response.text();
      let data;
      try { data = JSON.parse(text); } catch { data = {}; }
      throw new Error(data.error || `Erreur preview correctif (${response.status})`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    let currentEvent = '';

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });

      const lines = buffer.split('\n');
      buffer = lines.pop();

      for (const line of lines) {
        if (line.startsWith('event: ')) {
          currentEvent = line.slice(7).trim();
        } else if (line.startsWith('data: ')) {
          const data = JSON.parse(line.slice(6));
          if (currentEvent === 'status' && onStatus) onStatus(data.message);
          if (currentEvent === 'error') throw new Error(data.error || 'Erreur preview correctif');
          if (currentEvent === 'result') return data;
          currentEvent = '';
        }
      }
    }

    throw new Error('Stream SSE terminé sans résultat');
  }

  async createFixPR(payload) {
    const response = await fetch('/api/ai/create-fix-pr', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...authHeaders() },
      body: JSON.stringify(payload || {})
    });
    const text = await response.text();
    const data = text ? JSON.parse(text) : {};
    if (!response.ok) {
      throw new Error(data.error || `Erreur création PR (${response.status})`);
    }
    return data;
  }

  async suggestTestFix(payload) {
    const response = await fetch('/api/ai/suggest-test-fix', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...authHeaders() },
      body: JSON.stringify(payload || {})
    });
    const text = await response.text();
    const data = text ? JSON.parse(text) : {};
    if (!response.ok) {
      throw new Error(data.error || `Erreur suggestion correctif (${response.status})`);
    }
    return data;
  }

  async fetchTestCaseSteps(payload) {
    const response = await fetch('/api/ai/test-case-steps', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...authHeaders() },
      body: JSON.stringify(payload || {})
    });
    const text = await response.text();
    const data = text ? JSON.parse(text) : {};
    if (!response.ok) {
      throw new Error(data.error || `Steps indisponibles (${response.status})`);
    }
    return data;
  }

  async analyzeSuspectChanges(payload) {
    const response = await fetch('/api/ai/suspect-changes', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...authHeaders()
      },
      body: JSON.stringify(payload || {})
    });

    const text = await response.text();
    const data = text ? JSON.parse(text) : {};

    if (!response.ok) {
      throw new Error(data.error || `Erreur analyse changements suspects (${response.status})`);
    }

    return data;
  }
}

const aiAgentService = new AiAgentService();
export default aiAgentService;
